import React from 'react';
import { DateRangePicker } from '../../../CommonComponents/OPL/dates/DateRangePicker/DateRangePicker';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import {
  PortfolioReportParam,
  usePortfolioReportCache,
} from '../../api/usePortfolioReportParamsQuery';
import { MarginProps } from '../../../theme/styledProps';
import { useDateRangePickerWithPresets } from './useDateRangePickerWithPresets';
import { dateToString } from '../../utils/dates';

interface Props extends MarginProps {
  param: PortfolioReportParam;
}

export const DateRangePickerWithPresets: React.FC<Props> = ({ param, ...rest }) => {
  const { range, minDate, rangePresets, customPeriodEnabled } = useDateRangePickerWithPresets({
    param,
  });

  const { mutateParamCache } = usePortfolioReportCache();

  return (
    <Wrapper {...rest}>
      {param.displayName && (
        <Text variant="formLabel" color="neutral.600" mb="4" css="display: block">
          {param.displayName}
        </Text>
      )}

      <DateRangePicker
        aria-label={param.displayName ?? ''}
        range={range}
        onChange={_range => {
          mutateParamCache(param.id, {
            values: [dateToString(_range.dates[0]), dateToString(_range.dates[1])],
            range: _range,
          });
        }}
        presets={rangePresets}
        minDate={minDate}
        maxDate={new Date()}
        isReadonly={!customPeriodEnabled}
      />
    </Wrapper>
  );
};
